import { eUSAState } from 'ui-toolkit/enums/states';
import { addressDataToString } from 'ui-toolkit/orders/interfaces/IAddressResponse';
import { IOrderDetailsData } from 'ui-toolkit/orders/interfaces/IOrderDetailsData';
import { SpruceGeneralPhoneNumber } from 'utilities/Constants.PhoneNumbers';

const invalidMemoCharacter: RegExp = /[^a-zA-Z0-9,/_\- ]/g;
const multipleSpaces: RegExp = /  +/g;

export const defaultMemo = (order: IOrderDetailsData, isSpruceWithZillowEnabled: boolean, isZillowClosing: boolean) => {
  const {
    property: { street_address, unit, state, zip_code, city },
  } = order;
  const address = addressDataToString({
    streetAddress: street_address ?? '',
    unit: unit ?? '',
    city: city ?? '',
    stateAbbreviation: (state ?? 'NY') as eUSAState,
    zipCode: zip_code ?? '',
  });
  const companyName = isSpruceWithZillowEnabled ? 'Zillow' : 'Spruce';
  const phoneNumber = `${companyName} ${SpruceGeneralPhoneNumber}`;
  const fileNumber = isZillowClosing
    ? (order.transaction.file_number ?? '').substring(0, 11)
    : (order.transaction.file_number ?? '').substring(6);

  return `${address} / ${phoneNumber} / ${fileNumber}`
    .replaceAll(invalidMemoCharacter, ' ')
    .replaceAll(multipleSpaces, ' ');
};

export const defaultCheckMemo = (order: IOrderDetailsData) => {
  const {
    property: { street_address, unit, state, zip_code, city },
  } = order;
  const address = addressDataToString({
    streetAddress: street_address ?? '',
    unit: unit ?? '',
    city: city ?? '',
    stateAbbreviation: (state ?? 'NY') as eUSAState,
    zipCode: zip_code ?? '',
  });

  return `${address}`.replaceAll(invalidMemoCharacter, ' ').replaceAll(multipleSpaces, ' ');
};
